<template>
  <v-app>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script setup>
import { useProvideOccasionsStore } from '#root/lib/useOccasionsStore'

useProvideOccasionsStore()
</script>
